import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@p2p/shared/utils';
import { Observable } from 'rxjs';

import { PaymentProfileRestrictionsResponse } from '../entities/payment-restrictions-response';

@Injectable({ providedIn: 'root' })
export class PaymentProfileRestrictionsDataService {
    private readonly http = inject(HttpClient);

    private readonly url = '/rest/payment-profile-restrictions';

    loadRestrictions(): Observable<PaymentProfileRestrictionsResponse> {
        return this.http.get<PaymentProfileRestrictionsResponse>(`${environment.apiUrl}${this.url}`);
    }
}
